import { render, staticRenderFns } from "./left_account.vue?vue&type=template&id=3f99579d&scoped=true&"
import script from "./left_account.vue?vue&type=script&lang=js&"
export * from "./left_account.vue?vue&type=script&lang=js&"
import style0 from "./left_account.vue?vue&type=style&index=0&id=3f99579d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f99579d",
  null
  
)

export default component.exports